/* ─── MIL Model Data ──────────────────────────────────────────────────────── */
// Hardcoded rates removed in favor of dynamic uploaded data source


export const PREMIUM = new Set(["apple", "sony", "bose"]);

export const GSCORE = { a: 1.0, b: 0.65, c: 0.35, d: 0.12 };

export const SAMPLE_CSV = `item_id,category,brand,model,grade,retail_price
ITM-001,Cooking,Elica,Filterless Chimney,A,27990
ITM-002,Refrigeration,Samsung,Frost Free Refrigerator,B,83999
ITM-003,Laundry,Voltas Beko,Front Load Washing Machine,A,41990
ITM-004,Cooking,IFB,Solo Microwave Oven,B,8790
ITM-005,Dishwashers,Bosch,Standard Dishwasher,A,56990
ITM-006,Refrigeration,Haier,Side by Side Refrigerator,B,101990
ITM-007,Laundry,LG,Smart Inverter Washing Machine,C,28990
ITM-008,Cooking,Faber,Autoclean Chimney,B,32690
ITM-009,Dishwashers,Godrej,Counter-Top Dishwasher,A,30700
ITM-010,Refrigeration,Whirlpool,Triple-Door Refrigerator,C,34190
ITM-011,Laundry,IFB,AI Powered Washing Machine,A,40090
ITM-012,Cooking,Pigeon,Nano Wave Microwave,B,11995`;

export const CAT_ICON = { 
  Smartphone: "📱", Laptop: "💻", Tablet: "📟", Smartwatch: "⌚", Headphones: "🎧",
  Cooking: "🍳", Refrigeration: "❄️", Laundry: "🧺", Dishwashers: "🍽️", General: "📦" 
};

export const GRADE_STYLE = {
  A: { bg: "rgba(0, 208, 156, 0.15)", txt: "#00d09c", label: "Mint" },
  B: { bg: "rgba(0, 103, 255, 0.15)", txt: "#0067ff", label: "Good" },
  C: { bg: "rgba(245, 158, 11, 0.15)", txt: "#f59e0b", label: "Fair" },
  D: { bg: "rgba(239, 68, 68, 0.15)", txt: "#ef4444", label: "Poor" },
};

export const LOT_ACCENT = ["#0067ff", "#00d09c", "#3b82f6", "#10b981", "#6366f1", "#8b5cf6", "#0ea5e9"];
